// extracted by mini-css-extract-plugin
export default {"primaryLocation":"location_primary-location_primaryLocation"};